<template>
  <div class="aprove-selected">
    <vs-popup title="Atenção !!!" @close="onClose" :active.sync="popupActivo">
      <!-- <div class="separator"></div> -->
      <div class="content-modal">
        <div class="text-center">
          <p>
            <span>Você tem certeza de que quer Aprovar?</span>
          </p>
        </div>
      </div>
      <footer class="footer-modal">
        <hr>
        <div class="btn-group">
          <div class="btn-space"></div>
          <div class="btn-print-modal text-right">
            <b-button @click="clickYes" variant="info">Sim</b-button>
          </div>
          <div class="btn-aprove-modal text-right">
            <b-button @click="clickNo" variant="info">Não</b-button>
          </div>
        </div>
      </footer>
    </vs-popup>
  </div>
</template>

<script>
import axios from "axios";
import { baseApiUrlRH } from "@/global";
import { EventBusExpenses } from "@/eventBus/eventBusExpenses";

export default {
  name: "AproveSelected",
  props: ["collaboratorSelected", "yearMonthCurrent", "local"],
  data() {
    return {
      userContext: this.$store.state.userContext,
      loadingImport: true,
      popupActivo: false
    };
  },
  mounted() {
    this.listeningEventBus();
  },

  methods: {
    listeningEventBus() {
      EventBusExpenses.$on("popupActivoAproveSelected", data => {
        this.popupActivo = data;
      });
    },
    onClose() {
      this.$emit("closeAproveSelected", true);
    },
    clickYes() {
      this.loadingImport = true;
      this.$emit("closeAproveSelected", true);
      this.popupActivo = false;
      if (this.collaboratorSelected.length < 1) {
        this.loadingImport = false;
        this.showMessage(
          "Selecione um colaborador para gerar os Relatório de Despesa",
          "danger"
        );
        return;
      }
      this.sendToProthuesTableZRA010();
    },

    async sendToProthuesTableZRA010() {
      let data = await axios
        .post(
          `${baseApiUrlRH}/reportbenefits/insertAllZRA010/${
            this.yearMonthCurrent
          }/${this.userContext.userId}`,
          this.collaboratorSelected
        )
        .then(resp => resp.data);
      if (data != null) this.showMessage("Aprovado com sucesso !!!", "danger");
    },

    showMessage(message, type) {
      this.$vs.notify({
        title: "Aviso",
        text: message,
        color: type
      });
    },

    clickNo() {
      this.$emit("closeAproveSelected", true);
      this.popupActivo = false;
    }
  }
};
</script>

<style>
.footer-modal {
  height: 70px;
}
.btn-group {
  display: flex;
  width: 100%;
}
.btn-space {
  width: 100%;
}
.btn-aprove-modal {
  width: 100px;
}
.btn-print-modal {
  width: 100px;
}
</style>
